export const useThanksData = () => useState('thanks-page-data', () => null);
